import React from 'react';

import Loader from '../../components/Loader/Loader';

export const Loading = () => <Loader mainLoader />;
